<script setup lang="ts">
import { Paragraph } from "~/components/clarity-ui/Paragraph";
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";

export interface ProductOverviewLinkProps {
  link: {
    label: string;
    link: string;
    type: string;
  };
  text?: string;
}

const { text, link } = defineProps<ProductOverviewLinkProps>();
</script>

<template>
  <div
    class="relative flex flex-col items-start gap-3 rounded-2xl bg-light-blue p-4 hover:bg-medium-blue motion-safe:transition-colors motion-safe:duration-300"
  >
    <LinkComponent class="stretched-link font-medium text-black" :link="link">
      {{ link?.label }}
    </LinkComponent>
    <Paragraph size="small">{{ text }}</Paragraph>
  </div>
</template>
